export default function () {
  document.addEventListener('alpine:init', () => {
    const elements = document.querySelectorAll('.e-content') as NodeListOf<HTMLElement>;
    if (elements) {
      elements.forEach((element) => {
        replaceElementEmbeds(element);
      });
    }
  });
}

function replaceElementEmbeds(element: HTMLElement) {
  const iframes = element.querySelectorAll('iframe');
  if (iframes) {
    iframes.forEach((iframe) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('medium-editor-embeds');
      wrapper.setAttribute('contenteditable', 'false');

      const outerWrapper = document.createElement('div');
      outerWrapper.style.cssText = 'left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.25%;';
      wrapper.appendChild(outerWrapper);

      const src = iframe.getAttribute('src');
      if (src) {
        wrapper.setAttribute('data-original-link', src);
        iframe.setAttribute('data-src', src);
        iframe.removeAttribute('src');
      }

      if (iframe.parentNode) {
        iframe.parentNode.insertBefore(wrapper, iframe);
        outerWrapper.appendChild(iframe);
      }
    });
  }
}
